module.exports = __webpack_public_path__ + "img/03-info-03.d19cb97c.png";